import React, { useState } from 'react';
import HomeworkImageViewer from './HomeworkImageViewer';

const HomeworkImageDemo = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample homework images from the uploads folder
  const sampleImages = [
    {
      url: '/uploads/1754902726998-ccaqqq.png',
      title: 'Math Homework - Chapter 5'
    },
    {
      url: '/uploads/1754902816290-WhatsApp Image 2025-03-08 at 23.05.55_fc5f280a.jpg',
      title: 'Science Assignment'
    },
    {
      url: '/uploads/1754902844318-WhatsApp Image 2025-03-08 at 23.53.18_bc38257f.jpg',
      title: 'English Essay Topic'
    }
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '20px',
        borderRadius: '12px',
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        <h2 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>📚 Homework Images</h2>
        <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
          Click on any homework image to view and copy it to clipboard
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px'
      }}>
        {sampleImages.map((image, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              border: '2px solid #e2e8f0',
              borderRadius: '12px',
              padding: '15px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onClick={() => setSelectedImage(image)}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{
              width: '100%',
              height: '150px',
              background: '#f8fafc',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '10px',
              overflow: 'hidden'
            }}>
              <img
                src={image.url}
                alt={image.title}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'cover',
                  borderRadius: '6px'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div style={{
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '48px',
                color: '#9ca3af'
              }}>
                📄
              </div>
            </div>
            
            <h4 style={{
              margin: '0 0 8px 0',
              fontSize: '16px',
              color: '#1e40af',
              fontWeight: 'bold'
            }}>
              {image.title}
            </h4>
            
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: '#6b7280'
            }}>
              Click to view and copy to clipboard
            </p>
          </div>
        ))}
      </div>

      {/* Instructions */}
      <div style={{
        marginTop: '30px',
        padding: '20px',
        background: '#f0f9ff',
        borderRadius: '12px',
        border: '2px solid #3b82f6'
      }}>
        <h3 style={{ margin: '0 0 15px 0', color: '#1e40af', fontSize: '18px' }}>
          🎯 How to Copy Homework Images:
        </h3>
        <ol style={{ margin: 0, paddingLeft: '20px', color: '#374151' }}>
          <li style={{ marginBottom: '8px' }}>Click on any homework image above</li>
          <li style={{ marginBottom: '8px' }}>Click the "📋 Copy to Clipboard" button</li>
          <li style={{ marginBottom: '8px' }}>Open WhatsApp, email, or any other app</li>
          <li style={{ marginBottom: '8px' }}>Press Ctrl+V (or Cmd+V on Mac) to paste the image</li>
        </ol>
        <div style={{
          marginTop: '15px',
          padding: '10px',
          background: '#dbeafe',
          borderRadius: '6px',
          fontSize: '14px',
          color: '#1e40af'
        }}>
          💡 <strong>Note:</strong> This feature works best in modern browsers with HTTPS. 
          If copying fails, the image will be downloaded instead.
        </div>
      </div>

      {/* Image Viewer Modal */}
      {selectedImage && (
        <HomeworkImageViewer
          imageUrl={selectedImage.url}
          title={selectedImage.title}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </div>
  );
};

export default HomeworkImageDemo;